module.exports = __webpack_public_path__ + "img/PL.ed9d5529.svg";